module.exports = __webpack_public_path__ + "media/images/ico-video-0663034e.svg";